module.exports = __webpack_public_path__ + "static/media/raport_2.203d425a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/raport_2.jpg
// module id = 1887
// module chunks = 0